import React from 'react';
import { Tag } from '../Tag';

export const PartItem = ({ item }) => (
    <div className="hitem">
        <div className="hrow">
            <div className="h-name">
                <span className="src">{item.component}</span>
                {item.timesLabel && <span className="times"> · {item.timesLabel}</span>}
            </div>
            <Tag tone={item.tagStyle}>{item.status}</Tag>
            {item.visit && (
                <a className="chip" href={`#v${item.visit}`}>
                    <span className="hash">#</span>
                    {item.visit}
                </a>
            )}
        </div>
        <div className="hrow">
            {item.when && <div className="h-when">{item.when}</div>}
            {item.part && <div className="h-part">{item.part}</div>}
            {item.note && <div className="h-note">{item.note}</div>}
        </div>
        {item.strip && (
            <figure className="strip" aria-label={item.strip.aria}>
                <div className="strip-track">
                    <div className="strip-base" />
                    <div
                        style={{
                            position: 'absolute',
                            top: 24,
                            borderTop: '2px solid #E83E8C',
                            left: `${item.strip.span.left}%`,
                            width: `${item.strip.span.width}%`,
                        }}
                    />
                    {item.strip.gaps.map(gap => (
                        <span className="strip-gap" style={{ left: `${gap.left}%` }} key={gap.left}>
                            {gap.label}
                        </span>
                    ))}
                    {item.strip.dots.map(left => (
                        <span className="strip-dot" style={{ left: `${left}%` }} key={left} />
                    ))}
                </div>
                <div className="strip-axis">
                    {item.strip.ticks.map(tick => (
                        <span className="strip-tick" style={{ left: `${tick.left}%` }} key={tick.left}>
                            {tick.label}
                        </span>
                    ))}
                </div>
            </figure>
        )}
    </div>
);
